import type { ParentIssueType } from '@risksmart-app/domain/src/types/consts';
import type { GetIssuesByParentIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetIssuesByParentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIssuesByParentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetIssuesByParentIdArgs = {
  parentId: string;
  type: ParentIssueType;
};

export const useLazyGetIssuesByParentId = createLazyQueryHook<
  UseLazyGetIssuesByParentIdArgs,
  GetIssuesByParentIdResponseRow[],
  GetIssuesByParentIdQuery
>({
  trpcQuery: (client, { parentId, type }) =>
    client.frontend.issue.issuesByParentId.query({ parentId, type }),
  mapTrpcDataToGraphQL: (data) => ({ issue: data }),
  graphqlDocument: GetIssuesByParentIdDocument,
  graphqlVariables: ({ parentId, type }) => ({
    ParentId: parentId,
    Type: type,
  }),
});
